function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.593 11.625H4.5V5.949L.562 1.262V.375H11.25v.882L7.5 5.944v3.774l-1.907 1.907zm-.343-.75h.032L6.75 9.407V5.681l3.645-4.556H1.427l3.823 4.55v5.2z",
  fill: "#fff"
});

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNTkyODIgMTEuNjI1SDQuNVY1Ljk0OTA5TDAuNTYyNSAxLjI2MTU5VjAuMzc1SDExLjI1VjEuMjU2NTNMNy41IDUuOTQ0MDNWOS43MTc4Mkw1LjU5MjgyIDExLjYyNVpNNS4yNSAxMC44NzVINS4yODIxOEw2Ljc1IDkuNDA3MThWNS42ODA5N0wxMC4zOTQ4IDEuMTI1SDEuNDI3MzRMNS4yNSA1LjY3NTkxVjEwLjg3NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgFilter as ReactComponent };